// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMin } from 'frontend_core/dist/styles/media'
import ScrollControlView from 'components/atoms/ScrollControlView'
import { spacing } from 'frontend_core/dist/styles/variables'

const Contents = styled.div`
  padding: ${spacing.medium_3}px 0;
  ${mediaMin.phone`
    padding: ${spacing.large}px 0;
    ${({ topSpacing }) =>
      topSpacing &&
      css`
        padding: ${topSpacing}px 0;
      `}
  `};
`
const Main = styled.div`
  ${mediaMin.phone`
    width: 100%;
    max-width: 768px;
    margin: 0 auto;
  `};
`
const Inner = styled.div`
  padding: 0 ${spacing.medium}px;
`

type PropTypes = {
  isShowingModal?: ?boolean,
  children: any,
  topSpacing?: ?number,
}

export default (props: PropTypes) => (
  <ScrollControlView isLock={props.isShowingModal}>
    <Inner>
      <Main>
        <Contents topSpacing={props.topSpacing}>{props.children}</Contents>
      </Main>
    </Inner>
  </ScrollControlView>
)



// WEBPACK FOOTER //
// ./src/components/templates/MainContents/index.jsx